import classNames from 'classnames/bind';
import styles from './OrderArrow.module.css';

interface OrderArrowProps {
  classnames?: string[];
  clickHandler?: () => void;
}
export default function OrderArrow({
  classnames,
  clickHandler,
}: OrderArrowProps) {
  const cx = classNames.bind(styles);

  return (
    <span
      className={cx('btn', 'order_arrow', classnames)}
      onClick={clickHandler}
    ></span>
  );
}
